import './spinner.scss';

const Spinner = () => (
  <div className="spinner-wrapper">
    <div className="spinner-loader" />
  </div>
);

export default Spinner;
